import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import ComposerBody from 'flarum/forum/components/ComposerBody';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ConfirmDocumentUnload from 'flarum/common/components/ConfirmDocumentUnload';
import avatar from 'flarum/common/helpers/avatar';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';

/**
 * 场地交易页顶部公告（复用 Composer 壳层，通过 body  class 将 .App-composer 贴顶）
 */
export class BadmintonTradesAnnounceComposer extends ComposerBody {
  static initAttrs(attrs) {
    super.initAttrs(attrs);
    attrs.user = attrs.user || app.session.user;
    attrs.className = classList('BadmintonTradesAnnounceComposer', attrs.className);
  }

  hasChanges() {
    return false;
  }

  onremove(vnode) {
    document.body.classList.remove('App--badminton-trades-announce-composer');
    super.onremove(vnode);
  }

  view() {
    return (
      <ConfirmDocumentUnload when={() => false}>
        <div className={classList('ComposerBody', this.attrs.className)}>
          {avatar(this.attrs.user, { className: 'ComposerBody-avatar' })}
          <div className="ComposerBody-content">
            <ul className="ComposerBody-header">{listItems(this.headerItems().toArray())}</ul>
            <div className="ComposerBody-editor">
              <div className="TextEditor">
                <div
                  className="TextEditor-editorContainer FormControl Composer-flexible badminton-composer-flex badminton-trades-announce-editor"
                  style="overflow-x: hidden;"
                >
                  <div className="badminton-trades-announce-body">{this.attrs.body}</div>
                </div>
                <ul className="TextEditor-controls Composer-footer">
                  <li>
                    <Button className="Button Button--primary" onclick={() => app.composer.close()}>
                      {this.attrs.dismissLabel || '我知道了'}
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <LoadingIndicator display="unset" containerClassName={classList('ComposerBody-loading', this.loading && 'active')} size="large" />
        </div>
      </ConfirmDocumentUnload>
    );
  }

  headerItems() {
    const items = new ItemList();
    items.add('title', <h3>{this.attrs.title || '公告'}</h3>, 100);
    return items;
  }

  onsubmit() {}
}

function isAnnounceEnabled() {
  const v = app.forum.attribute('acme-pku-badminton.trades_announce_enable');
  return v === true || v === 1 || v === '1';
}

/**
 * 进入 /badminton/trades 且配置开启、正文非空时展示；不抢占用户正在使用的 Composer
 */
export function maybeShowBadmintonTradesAnnounce() {
  if (!isAnnounceEnabled()) return;
  const body = String(app.forum.attribute('acme-pku-badminton.trades_announce_body') || '').trim();
  if (!body) return;

  if (app.composer.isVisible()) {
    if (typeof app.composer.bodyMatches === 'function' && app.composer.bodyMatches(BadmintonTradesAnnounceComposer)) {
      return;
    }
    return;
  }

  const title = String(app.forum.attribute('acme-pku-badminton.trades_announce_title') || '').trim() || '公告';

  document.body.classList.add('App--badminton-trades-announce-composer');
  app.composer.load(BadmintonTradesAnnounceComposer, {
    title,
    body,
    dismissLabel: app.translator.trans('acme-pku-badminton.forum.trades_announce.dismiss'),
  });
  app.composer.show();
}
